import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';

// import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import * as $ from 'jquery';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {


  // deactivate1 = new FormGroup({
  //   jioId: new FormControl()
  // })
  panelOpenState1 = false;
  panelOpenState2 = false;
  screenW = false;


  res: any = "";
  submitted3 = false;

  submitted1 =false;
  mobilno: any;
  contenthide = true ;
  successcontenthide = true;
demohide =true;
  fragment: string;
  iphonecontenthide=true;


  constructor(private formBuilder: FormBuilder, private http: HttpClient, private router: Router, private dialog: MatDialog,private route: ActivatedRoute,
    public dialog_1: MatDialogRef<TemplateRef<any>>, public dialog_2: MatDialogRef<TemplateRef<any>>,
    public dialog_3: MatDialogRef<TemplateRef<any>>, public dialog_4: MatDialogRef<TemplateRef<any>>,
    public dialog_5: MatDialogRef<TemplateRef<any>>) { }
  //   private cd : ChangeDetectorRef,
  //   config: NgbModalConfig, private dialog: NgbModal) {
  //     config.backdrop = 'static';
  //     config.keyboard = false;  
  //     config.windowClass = 'custom-class'
  // }

  

  ngOnInit() {
    
    // document.getElementById("defaultOpen").click();
    // intro edit
    // console.log(window.screen.width);
    if(window.screen.width >= 1100){  //class=aside visibility for desktop
      this.screenW = true;
    }
    else{
      this.screenW = false;
    }
    

    this.modal1 = this.formBuilder.group({

      jioId: ['', [Validators.required, Validators.pattern('^^[0-9]{10}$')]]
    })
    
    this.route.fragment.subscribe(f => {
      const element = document.querySelector("#" + f)
      if (element) element.scrollIntoView()
    })
  
  }

  lost1(){
    // console.log("hi");
    this.panelOpenState1 = !this.panelOpenState1;
  }
  device(){
    // console.log("hi");
    this.panelOpenState2 = !this.panelOpenState2;
  }

  refreshpage(){
    location.reload();

  }
  // ngAfterViewInit(): void {
  //   try {
      
  //   } catch (e) { }
  // }
  // get f1() { return this.deactivate1.controls; }
  scroll() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth', block: 'center' });
 }

  // openCity(evt, status) {

  //   var i, tabcontent, tablinks;
  //   tabcontent = document.getElementsByClassName("tabcontent");
  //   // tabcontent2 = document.getElementsByClassName("tabcontent2");

  //   for (i = 0; i < tabcontent.length; i++) {
  //     tabcontent[i].style.display = "none";
  //     // tabcontent2[i].style.display = "none";
  //   }
  //   tablinks = document.getElementsByClassName("tablinks");
  //   for (i = 0; i < tablinks.length; i++) {
  //     tablinks[i].className = tablinks[i].className.replace(" active", "");
  //   }
  //   document.getElementById(status).style.display = "block";
  //   evt.currentTarget.className += " active";
  // }


  loginPage(){
    //console.log("redirect to login page");
    
    this.router.navigateByUrl("/login")
  }
  showModal(content) {    
    this.contenthide = false;
     this.dialog_1 =  this.dialog.open(content,{
      panelClass: 'custom-dialog-container',
      autoFocus :false,
      restoreFocus : true,
      role :'dialog',
      disableClose : true,

      // height:'200px'
      // padding-left: '17%';
      // padding-right: '17%';
      
    })


  }
  modal1 = new FormGroup({
    jioId: new FormControl()
  });

  getlink(successcontent, failurecontent, content) {
    this.submitted1 = true;
    if (this.modal1.invalid) {
     document.getElementById("errormessage").style.display="block"; 
    }
else{

  document.getElementById("errormessage").style.display="none";
    let data = { "phoneno": this.modal1.value.jioId }
    this.mobilno = this.modal1.value.jioId;
    this.http.post(environment.validate, data).subscribe(
      data => {
        //console.log(data);

        this.res = data;
        if (this.res.status == "OK") {
   
          this.contenthide = true;
          this.successcontenthide = false;
         this.dialog_2 =  this.dialog.open(successcontent,{
            panelClass: 'success-dialog-container',
            restoreFocus : true,
            role :'dialog',
            autoFocus:false,
            disableClose : true,
            // height:'200px'
            // padding-left: '17%';
            // padding-right: '17%';
            
          })


        }
        else {
          // this.dialog.closeAll()
          // this.dialog_1.close();
          // this.dialog_1.afterClosed().subscribe(result => {
          //   //console.log("closed dialog");
             
          // });
          this.contenthide = true;
          
         this.dialog_3 =  this.dialog.open(failurecontent,{
            panelClass: 'failure-dialog-container',
            
            // backdropClass: 'failurebackdrop'
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
            
            // }
         
            
          })
        }

        ;
      })
    }
  }

  dismissmodal() {
    this.dialog.closeAll()
    this.modal1.reset();

  }


  get f() { return this.modal1.controls; }

  openapk() {

    this.dismissmodal();
    // window.open('./assets/apk/JioID-1.0.4.apk');
    window.open(environment.androidlink);



  }

  openipapk(){
this.dismissmodal();
window.open(environment.iOSlink);
  }

  sendphonelink1(successcontent,successlinksent,failurelinksent) {   this.submitted1 = true;
    if (this.modal1.invalid) {
  
  
      document.getElementById("errormessage").style.display="block";
  
  
  
    }
  else{
  
  document.getElementById("errormessage").style.display="none";
    
    let data = {
      "phoneno": this.modal1.value.jioId,
      "flag": "0"
    }
  //console.log(data);
    this.http.post(environment.sendSms, data).subscribe(
      data => {
        //console.log(data);
  
        this.res = data;
        if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.contenthide = true;

  
          const dialog_ref =  this.dialog.open(successlinksent,{
            panelClass: 'customlink-dialog-container',
           
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
          
            
          })
        }
        else {
          // this.dialog.closeAll()
          this.contenthide = true;
  
          const dialog_ref =  this.dialog.open(failurelinksent,{
            panelClass: 'customlink-dialog-container',
            
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
            
          })
  
        }
  
        ;
      },
      err =>{
        this.contenthide = true;
  
        const dialog_ref =  this.dialog.open(failurelinksent,{
          panelClass: 'customlink-dialog-container',
          
          disableClose:true,
        
          restoreFocus : false,
          role :'dialog',
          autoFocus:false,
          
        })

      })
    }
  };  
  sendphonelink2(successcontent,successlinksent,failurelinksent) {
    this.submitted1 = true;
    if (this.modal1.invalid) {
  
  
      document.getElementById("errormessage").style.display="block";
  
  
  
    }
  else{
  
  document.getElementById("errormessage").style.display="none";
    let data = {
      "phoneno": this.modal1.value.jioId,
      "flag": "1"
    }
  //console.log(data);
    this.http.post(environment.sendSms, data).subscribe(
      data => {
        //console.log(data);
        this.res = data;
        if (this.res.status == "SMS Send Successfully") {
          // this.dialog.closeAll()
          this.iphonecontenthide = true;
  
          const dialog_ref =  this.dialog.open(successlinksent,{
            panelClass: 'customlink-dialog-container',
            
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
            
          })
  
  
        }
        else {
          // this.dialog.closeAll()
          this.iphonecontenthide = true;
  
          const dialog_ref =  this.dialog.open(failurelinksent,{
            panelClass: 'custom-dialog-container',
            
            disableClose:true,
          
            restoreFocus : false,
            role :'dialog',
            autoFocus:false,
            
          })
  
        }
  
        ;
      },
      err =>{
        this.iphonecontenthide = true;

  
        const dialog_ref =  this.dialog.open(failurelinksent,{
          panelClass: 'customlink-dialog-container',
          
          disableClose:true,
        
          restoreFocus : false,
          role :'dialog',
          autoFocus:false,
          
        })

      })
    }
    }
  showModal1(successcontent){
    
    this.successcontenthide = false;
    this.dialog_2 =  this.dialog.open(successcontent,{
       panelClass: 'success-dialog-container',
       restoreFocus : true,
       role :'dialog',
       autoFocus:false,
       disableClose : true,
       // height:'200px'
       // padding-left: '17%';
       // padding-right: '17%';
       
     })

  }
  sendandroidphonelink(content){
    this.successcontenthide = true;
    this.contenthide = false;
    this.dialog_1 =  this.dialog.open(content,{
     panelClass: 'custom-dialog-container',
     autoFocus :false,
     restoreFocus : true,
     role :'dialog',
     disableClose : true,

     // height:'200px'
     // padding-left: '17%';
     // padding-right: '17%';
     
   })


  }
  sendiphonelink(iphonecontent){
    this.successcontenthide = true;

    this.iphonecontenthide = false;
    this.dialog_1 =  this.dialog.open(iphonecontent,{
     panelClass: 'custom-dialog-container',
     autoFocus :false,
     restoreFocus : true,
     role :'dialog',
     disableClose : true,

     // height:'200px'
     // padding-left: '17%';
     // padding-right: '17%';
     
   })


  }
 
}

